<template>
  <div class="calico-document-list-item-page">
    <div class="calico-file-item-container">
      <CalicoDocumentListItem
        year="2025"
        filename="my-file.pdf"
      />
    </div>
  </div>
</template>

<script lang="js">
import CalicoDocumentListItem from '@/components/calico/documentListItem/index.vue'
export default {
  name: 'CalicoDocumentListItemPage',
  components: {
    CalicoDocumentListItem
  },
  data () {
    return {}
  },
}
</script>
<style lang="scss">
.calico-document-list-item-page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
  .calico-file-item-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 459px;
  }
  .calico-file-item-container-2 {
    @include stack-space($space-large);
    @include inset-space($space-large);
    background: $color-neutral-darkest;
    width: 459px;
  }
}
</style>
